/**
 * Options for radio/select
 */

const options = {};

options.backgroundType = [
	{ label: 'Color', value: 'color' },
	{ label: 'Gradient', value: 'gradient' },
	{ label: 'Image', value: 'image' },
];

export default options;



// WEBPACK FOOTER //
// ./src/data/options.js